import { useEffect, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { Count, PageNumbers, PageSpan } from './Pagination.styled';
import moment from 'moment';
import { useStore } from '@store/appStore';
import db from '@utils/db';
import PageArrowR_Icon from "@assets/svg/pagearrow.svg";
import PageArrowL_Icon from "@assets/svg/pagearrowleft.svg";
import PageArrowLD_Icon from "@assets/svg/pagearrowleftdouble.svg";
import PageArrowRD_Icon from "@assets/svg/pagearrowrightdouble.svg";

interface IProps { currentPage: number, maxPage: number, setPage: (page) => void, count: number, pageSize: number }

export const Pagination = (props: IProps) => {
  const { client } = useStore();
  const i18n = useI18n();

  const getPageNumbers = () => {
    let pages = []

    let start = props.currentPage - 5;
    let end = props.currentPage + 5;
    if (start < 1) start = 1;
    if (end > props.maxPage) end = props.maxPage;


    for (let i = start; i <= end; i++) {
      pages.push(<PageSpan key={"page_" + i} onClick={() => props.setPage(i)} active={props.currentPage === i}>{i}</PageSpan>)
    }
    return pages
  }

  return (<>
    <Count>{((props.currentPage - 1) * props.pageSize) + 1} - {(props.currentPage * props.pageSize < props.count ? props.currentPage * props.pageSize : props.count)} {i18n.t("of")} {props.count}</Count>
    <PageNumbers>
      <PageSpan onClick={() => props.setPage(1)} disable={props.currentPage < 2}><PageArrowLD_Icon /></PageSpan>
      <PageSpan onClick={() => props.setPage(props.currentPage - 1)} disable={props.currentPage < 2}><PageArrowL_Icon /></PageSpan>
      {getPageNumbers()}
      <PageSpan onClick={() => props.setPage(props.currentPage + 1)} disable={!(props.currentPage < props.maxPage)}><PageArrowR_Icon /></PageSpan>
      <PageSpan onClick={() => props.setPage(props.maxPage)} disable={!(props.currentPage < props.maxPage)}><PageArrowRD_Icon /></PageSpan>
    </PageNumbers>
  </>);
};

export default Pagination;
